export default __webpack_public_path__ + "static/comment-4248fa111c9645d3356c3ab4b5dfc362.jpg";